import './App.css';
import { getMovieList, searchMovie } from './Api';
import { useEffect, useState } from 'react';

const App = () => {
const [popularMovies, setPopularMovies] = useState([])

useEffect(() => {
  getMovieList().then((result) => {
    setPopularMovies(result)
  })
}, [])


const PopularMovieList = () => {
  return popularMovies.map((movie, i) => {
    return (


      <div className="Movie-wrapper" key={i}>
          <div className="Movie-title">{movie.title}</div>
          <img 
          className="Movie-image" 
          src={`${process.env.REACT_APP_BASEIMGURL}/${movie.poster_path}`}/>
          <div className="Movie-date">Release Date {movie.release_date}</div>
          <div className="Movie-rate">{movie.vote_average}</div>
        </div>
    )
  })
}


const search = async (q) => {
 const query = await searchMovie(q)
 setPopularMovies(query.results)
}

  return (
    <div className="App">

           
<div className="Navbar">
        <div className="Navbar-title">
          <h1>CINEMA XXX</h1>
        </div>
        <div className="Navbar-link">
          <a href="#">Home</a>
          <a href="#">Contact</a>
          <a href="#">About</a>
        </div>
        </div>   
      <header className="App-header"> 
        
        <h1>Search Movie</h1>

        <input placeholder="Cari film anda"
        className="Movie-search"
        onChange={({ target }) => search(target.value)}
        />
        
        <div className="Movie-container">
        <PopularMovieList />
      </div>
        
      </header>
    </div>
  );
}

export default App;
